import * as React from "react";
import classnames from "classnames";
/* empty css                      */
const StoreDetailImage = ({
  className,
  storeDetailImageUrl,
  isFallbackImage,
  width,
  height,
  alt,
  ...rest
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    ...rest,
    className: classnames(className, "store-detail-image-stores-v2", {
      "store-detail-image-stores-v2--fallback": isFallbackImage
    })
  },
  /* @__PURE__ */ React.createElement(
    "img",
    {
      className: "store-detail-image-stores-v2__image",
      "data-t": "StoreDetailImage",
      alt,
      src: storeDetailImageUrl,
      width,
      height
    }
  )
);
export {
  StoreDetailImage as default
};
//# sourceMappingURL=StoreDetailImage.js.map
